import createCrudVuexModule from "@/store/crud";

export const policy = createCrudVuexModule({
  namespaced: true,
  path: "/library/policy",
});

export const workspacePolicy = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/policy",
});

export const managementPolicy = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/policy",
  actions: {
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        await dispatch("update", payload);
      } else {
        await dispatch("create", payload);
      }
      commit("reset");
    },
  },
});

export const managementPolicyCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/policy-category",
});

export const workspacePolicyCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/policy-category",
});

export const libraryPolicyCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/policy-category",
});
